export default __webpack_public_path__ + "static/FAQ-8bc41437dcf3f90ae9819cb395672371.pdf";